import { ChangeDetectionStrategy, Component, HostBinding, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Params } from '@angular/router';
import { ErrorCode } from '@common/http/enums/error-code.enum';
import { AuthRoute } from '@portal-core/auth/enums/auth-route.enum';
import { AuthRouteService } from '@portal-core/auth/services/auth-route.service';
import { AuthUrlService } from '@portal-core/auth/services/auth-url.service';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { AuthRouteCommand } from '@portal-core/auth/types/auth-route-command.type';
import { ErrorService } from '@portal-core/errors/services/error.service';
import { LoadingState } from '@portal-core/util/loading-state';
import { WINDOW } from '@portal-core/util/window.provider';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'mc-license-url-card',
  templateUrl: './license-url-card.component.html',
  styleUrls: ['./license-url-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LicenseURLCardComponent implements OnInit {
  /** Applies the mc-license-url-card class to the host element. */
  @HostBinding('class.mc-license-url-card') hostClass: boolean = true;

  loadingState: LoadingState<ErrorCode> = new LoadingState<ErrorCode>();
  loginRouteCommands$: Observable<any[]>;
  portalRootDomain: string;
  queryParams: Params;
  vanity: string;

  constructor(
    @Inject(WINDOW) private window: Window,
    private authService: AuthService,
    private authRouteService: AuthRouteService,
    private authUrlService: AuthUrlService,
    private errorService: ErrorService
  ) { }

  ngOnInit() {
    this.portalRootDomain = this.authUrlService.getRootDomain();

    this.loginRouteCommands$ = this.authRouteService.getAuthRedirect$(AuthRoute.Login).pipe(
      map((redirect: AuthRouteCommand) => redirect.commands)
    );
  }

  onSubmit(urlForm: NgForm) {
    if (urlForm.invalid) {
      return;
    }

    this.loadingState.update(true);

    this.authService.getIsVanityUrlPresent$(this.vanity).subscribe({
      next: result => {
        // If the result succeeded then the vanity is present and can be navigated to
        if (result.Succeeded) {
          this.window.location.href = this.authUrlService.buildSubdomainUrl(this.vanity);
        } else {
          this.loadingState.update(false, ErrorCode.GenericLicenseVanityVerificationError, this.errorService.getErrorCodes(result));
        }
      },
      error: error => {
        this.loadingState.update(false, ErrorCode.GenericLicenseVanityVerificationError, this.errorService.getErrorCodes(error));
      }
    });
  }
}
